import Link from '../Link/Link'
import config from '../../../config'
import { useEffect, useState } from 'react'
import { NextPreviousStyle } from './NextPrevious.css'



const NextPrevious = ({location}) => {

  const [prev,setPrev] = useState(null)
  const [next,setNext] = useState(null)

  useEffect(() => {
    const active = document.querySelector(".leftSidebar .active")

    const prev = active?.previousSibling
    let next = document.querySelector(".leftSidebar .active ul .item")
    if(next == null)
      next = active?.nextSibling

    setPrev(prev != null ? {
      text: prev.firstChild.textContent,
      href: prev.firstChild.pathname.replace(config.gatsby.pathPrefix,'')
    } : null)
    
    setNext(next != null ? {
      text: next.firstChild.textContent,
      href: next.firstChild.pathname.replace(config.gatsby.pathPrefix,'')
    } : null)

    

  },[location])


return <div css={NextPreviousStyle}>

  { prev && 
  <Link to={prev.href} className={'previousBtn'}>
               <div className={'arrow leftArrow'}>
                <svg preserveAspectRatio='xMidYMid meet' height='1em' width='1em' 
                  fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' strokeWidth='2'
                  strokeLinecap='round' strokeLinejoin='round' stroke='currentColor'
                >
                  <g>
                    <line x1='19' y1='12' x2='5' y2='12' />
                    <polyline points='12 19 5 12 12 5' />
                  </g>
                </svg>
              </div>
              <div className={'preRightWrapper'}>
                <div className={'smallContent'}>
                  <span>{config.siteMetadata.language == "sv" ? "Föregående" : "Previous"}</span>
                </div>
                <div className={'nextPreviousTitle'}>
                  <span>{prev.text}</span>
                </div>
              </div>
            </Link> 
    }
    { next && 
    <Link to={next.href} className={'nextBtn'}>
      <div className={'nextRightWrapper'}>
        <div className={'smallContent'}>
          <span>{config.siteMetadata.language == "sv" ? "Nästa" : "Next"}</span>
        </div>
        <div className={'nextPreviousTitle'}>
          <span>
            {next.text}
          </span>
        </div>
      </div>
      <div className={'arrow rightArrow'}>
        <svg preserveAspectRatio='xMidYMid meet' height='1em' width='1em' fill='none'
          xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' strokeWidth='2' strokeLinecap='round'
          strokeLinejoin='round' stroke='currentColor'
        >
          <g>
            <line x1='5' y1='12' x2='19' y2='12' />
            <polyline points='12 5 19 12 12 19' />
          </g>
        </svg>
      </div>
    </Link>
    }
  
  


</div>

}

export default NextPrevious